export const MESSAGE_TYPE_TEXT = {
  INFO_BANNER: 'Subscription policy can’t be updated once message type is created.',
  CREATE_ACTION_BUTTON: 'Create message type',
  UPDATE_ACTION_BUTTON: 'Save message type',
  UPDATE_TYPE_TO_DOUBLE_OPT_IN_BUTTON: 'Update to double opt-in',
  UPDATE_ACTION_BUTTON_DOUBLE_OPT_IN: 'Save',
  CREATE_SUCCESS_MESSAGE: 'Success! Created:',
  CREATE_ERROR_MESSAGE: 'Unable to create message type.',
  UPDATE_SUCCESS_MESSAGE: 'Success! Edited:',
  UPDATE_ERROR_MESSAGE: 'Unable to update message type.',
  INPUT_ERROR_TEXT: 'Please enter a value.',
};

export const DOUBLE_OPT_IN_PREVIEW_CONTENT = {
  CONFIRMATION_SENDER_LABEL: 'Double opt-in confirmation',
  OPT_IN_USER_LABEL: 'Double opt-in SMS',
  LEGAL_DISCLAIMER_SENDER_LABEL: 'Legal disclaimer',
  CONFIRMATION_MESSAGE_ACTION_PROMPT: ': Reply Y to subscribe to text messages about ',
  CONFIRMATION_MESSAGE_BRAND_CONNECT: '\n\u2022 Your relationship with ',
  LEGAL_DISCLAIMER_MESSAGE:
    ': Msg & data rates may apply. Msg frequency varies. Reply HELP for help, STOP to cancel. Disclaimer: ',
};

export const FORM_ERROR_BANNER_CONTENT = 'Oops! Please correct the highlighted fields.';

export const DOI_DOCUMENTATION_LINK = 'https://support.iterable.com/hc/articles/25573476484372';

export const BRAND_NAME_FIELD_LENGTH_LIMIT = 50;
export const MESSAGING_INITIATIVE_FIELD_LENGTH_LIMIT = 100;
export const SMS_DISCLAIMER_LINK_FIELD_LENGTH_LIMIT = 100;
